import { catalogOpsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

/** One enriched-attribute override submitted from the compare grid. */
export interface UpdateEnrichedAttributePayload {
  /** snake_case wire field name the endpoint is keyed by, e.g. `product_title`. */
  field: string;
  /** Value in the attribute's own JSON shape; the backend coerces it to the field's declared catalog type. */
  value: unknown;
  /** Enrichment connector — `META` for the scheduled Meta flow; omitted (defaults to `GMC`) for the experiment flow. */
  connectorCode?: string;
}

/**
 * Persists a single operator edit to an enriched attribute, reusing the frozen
 * catalog-operations PATCH endpoint. The compare grid has no dedicated
 * enrichment-edit endpoint of its own, so it hits the same curation-keyed route
 * (`products/{feed_product_id}/attributes/{field}`). Errors propagate untouched
 * so the caller's `onError` can surface the real failure.
 */
export async function updateEnrichedAttribute(
  productId: string,
  { field, value, connectorCode }: UpdateEnrichedAttributePayload,
): Promise<void> {
  await catalogOpsClient.patch(endpoints.catalogOperations.productAttribute(productId, field), {
    json: { field, value },
    searchParams: connectorCode ? { connectorCode } : {},
  });
}
